import React from 'react';
import { TIME_DASH_VIEW_COLORS, TIME_DASH_VIEW_LEGEND } from '@awp/constants';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const SensorStateRectangles = ({ data, isMedium, index, WeatherStationName }) => {
  const style = {
    width: '20px',
    height: '22px',
    backgroundColor: TIME_DASH_VIEW_COLORS[data?.Color - 1],
    borderRight: '1px solid #0D0D0D',
    flex: '1 1 auto',
    position: 'relative',
  };

  return (
    <>
      {data && (
        <OverlayTrigger
          placement="auto"
          overlay={
            <Tooltip id={`tooltip-${index}`} style={{ opacity: '0.7' }}>
              <>
                <b>{data?.CollectionTimeLocal}</b>
                <br />
                {isMedium ? (
                  TIME_DASH_VIEW_LEGEND[data?.Color - 1]
                ) : (
                  <>
                    {TIME_DASH_VIEW_LEGEND[data?.Color - 1]}
                    <br />
                    {WeatherStationName}
                  </>
                )}
              </>
            </Tooltip>
          }
        >
          <div style={style} />
        </OverlayTrigger>
      )}
    </>
  );
};

export default SensorStateRectangles;
